import { useWidgetData } from '../useWidgetData'

import { StatisticValueMetadata } from '../../../types/court/court'
import { ReportInterval } from '../../../types/report/report'
import { createReportQuery } from '../../../utils/reportUtils'

export const useTotalRevenueWidget = (interval: ReportInterval) =>
  useWidgetData<StatisticValueMetadata>(
    `total-revenue?${createReportQuery(interval)}`
  )
